import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

const getAuthConfig = () => {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// =====================================================
// GET ENGAGEMENT EVENTS
// =====================================================

export const getEngagementsApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append("page", payload.page || 1);
    formData.append("limit", payload.limit || 10);

    formData.append(
      "search",
      payload.search || ""
    );

    formData.append(
      "content_type",
      payload.content_type || ""
    );

    formData.append(
      "event_type",
      payload.event_type || ""
    );

    formData.append(
      "user_id",
      payload.user_id || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/engagement/list`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load engagement events.",
    };
  }
};

// =====================================================
// ENGAGEMENT STATS
// =====================================================

export const getEngagementStatsApi = async () => {
  try {
    const formData = new FormData();

    const res = await axios.post(
      `${apiBaseUrl}admin/engagement/stats`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load engagement statistics.",
    };
  }
};

// =====================================================
// GET SINGLE ENGAGEMENT EVENT
// =====================================================

export const getEngagementApi = async (engId) => {
  try {
    const formData = new FormData();

    formData.append(
      "eng_id",
      engId
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/engagement/view`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load engagement event.",
    };
  }
};